import styled from 'styled-components';
import { rgba } from 'polished';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 200px);
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    grid-template-columns: repeat(4, 140px);
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    grid-template-columns: repeat(2, 140px);
  }
`;

export const Wrapper = styled.div`
  padding: 0 7rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 0;
  }
`;

export const Links = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  opacity: 0;
  z-index: 1;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.functional.white};
  background-color: ${({ theme }) => `${rgba(theme.colors.primary.main, 0.8)}`};
  border-radius: ${({ theme }) => theme.borderRadius.main};
  backdrop-filter: blur(0.2rem);
  svg {
    width: 3.2rem;
    display: block;
    margin: 0 1rem;
    fill: ${({ theme }) => theme.colors.functional.white};
  }
`;

export const PhotoWrapper = styled.div`
  position: relative;
  overflow: hidden;
  aspect-ratio: 1/1;
  border-radius: ${({ theme }) => theme.borderRadius.main};
  img {
    filter: grayscale(100%);
    height: 100%;
    width: 100%;
  }
  :hover {
    ${Links} {
      opacity: 1;
    }
  }
`;

export const Content = styled.div`
  padding: 2rem 0;
  h4 {
    text-transform: capitalize;
  }
  span {
    padding: 1rem 0 4rem;
    display: block;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.functional.darkGray};
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 1rem 0;
    span {
      padding: 1rem 0 2rem;
    }
  }
`;
